import { v4 } from 'uuid'
export class ProdutoCatalogo {
  constructor ({
    id,
    produto_id,
    unidade_negocio_id,
    unidade_negocio_nome_fantasia,
    fornecedor,
    preco1,
    preco2,
    preco3,
    preco4,
    preco5,
    estoque,
    pedido_min,
    checked,
    saved = true,
  } = { id: v4() }) {
    this.id = id
    this.produto_id = produto_id
    this.unidade_negocio_id = unidade_negocio_id
    this.unidade_negocio_nome_fantasia = unidade_negocio_nome_fantasia
    this.fornecedor = fornecedor
    this.preco1 = preco1
    this.preco2 = preco2
    this.preco3 = preco3
    this.preco4 = preco4
    this.preco5 = preco5
    this.estoque = estoque
    this.pedido_min = pedido_min
    this.checked = checked || false
    this.saved = saved
  }
}

export function createProdutoCatalogo (data) {
  return Object.freeze(new ProdutoCatalogo(data))
}
